if (!customElements.get('top-sellers')) {
  class TopSellers extends HTMLElement {
    constructor() {
      super()

      let topSplideSlide = this.querySelectorAll('.top-sellers__splide__slide');

      if( topSplideSlide.length <= 3 ) {
        this.querySelector('.js-slider').classList.add('no-slider-arrows');
      }

      let splide = new Splide(this.querySelector('.js-slider'), {
        rewind: true,
        slideFocus: false,
        pagination: false,
        arrows: true,
        perPage: 3,
        breakpoints: {
          989: { perPage: 2 },
          768: { perPage: 2 },
          640: { perPage: 1 },
        },
      });

      let bar = splide.root.querySelector('.js-progesss-bar');

      splide.on('mounted move resized', () => {
        let end = (splide.Components.Controller.getEnd() || -1) + 1;
        if (end > 0) {
          bar.style.width = String(100 * (splide.index + 1) / end) + '%';
        } else {
          bar.style.width = '100%';
        }
        this.toggleArrows()
      });

      splide.mount();
    }

    toggleArrows() {
      let disabled = true
      this.querySelectorAll('.splide__arrow').forEach(arrow => {
        if (!arrow.disabled) disabled = false
      })
      if (disabled) {
        this.querySelector('.js-slider')?.classList.add('hide-arrows')
      } else {
        this.querySelector('.js-slider')?.classList.remove('hide-arrows')
      }
    }
  }

  customElements.define('top-sellers', TopSellers)
}
